module.exports = __webpack_public_path__ + "static/media/endsars.815cc56a.png";